// extracted by mini-css-extract-plugin
export default {"container":"TableBody_container__aC9wj"};